import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Smartphone, AlertTriangle } from 'lucide-react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface SessionConflictDialogProps {
  open: boolean;
  existingIp: string;
  lastActivity: string;
  onForceLogout: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export const SessionConflictDialog = ({
  open,
  existingIp,
  lastActivity,
  onForceLogout,
  onCancel,
  isLoading = false,
}: SessionConflictDialogProps) => {
  const formattedTime = lastActivity 
    ? format(new Date(lastActivity), "dd/MM/yyyy 'às' HH:mm", { locale: ptBR })
    : 'Desconhecido';

  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="bg-slate-800 border-orange-500/30">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-white">
            <AlertTriangle className="h-5 w-5 text-orange-500" />
            Sessão Ativa em Outro Dispositivo
          </AlertDialogTitle>
          <AlertDialogDescription className="text-blue-200/70 space-y-4">
            <p>
              Você já está logado no Modo Rota em outro dispositivo ou navegador.
            </p>
            
            <div className="bg-slate-700/50 p-4 rounded-lg space-y-2">
              <div className="flex items-center gap-2 text-sm">
                <Smartphone className="h-4 w-4 text-orange-400" />
                <span className="text-blue-100">Dispositivo ativo:</span>
              </div>
              <div className="text-xs text-slate-400 pl-6">
                <p>IP: {existingIp}</p>
                <p>Último acesso: {formattedTime}</p>
              </div>
            </div>
            
            <p className="text-sm">
              Deseja encerrar a sessão no outro dispositivo e continuar aqui?
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel 
            onClick={onCancel}
            className="bg-slate-700 border-slate-600 text-white hover:bg-slate-600"
            disabled={isLoading}
          >
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onForceLogout}
            className="bg-orange-500 text-white hover:bg-orange-600"
            disabled={isLoading}
          >
            {isLoading ? 'Encerrando...' : 'Encerrar Outra Sessão'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
